import { render } from "./NapCheck.vue?vue&type=template&id=0a706c53&scoped=true&ts=true"
import script from "./NapCheck.vue?vue&type=script&lang=ts"
export * from "./NapCheck.vue?vue&type=script&lang=ts"

import "./NapCheck.vue?vue&type=style&index=0&id=0a706c53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a706c53"]])

export default __exports__